import React, {createContext} from "react";
import {Blog} from "interfaces";
import useFetch from "hooks/fetch";
import dateFormat from "dateformat";

type ContextProps = [
    isLoading    : boolean,
    datasource   : Blog[]
]

export const BlogContext = createContext<ContextProps>([false, []]);

export const BlogProvider : React.FC = (props) => {

    const [isLoading, datasource] = useFetch("blog");

    const parseContent = (datasource : Blog[]) : Blog[] => {

        return datasource.map((item : Blog) => {

            let content = item.content
                ? item.content.replace(/(<([^>]+)>)/gi, "")
                : "";

            let date = item?.timestamp
                ? dateFormat( new Date(item?.timestamp?.toDate()), "dd mmmm yyyy")
                : "";

            return {...item, content, timestamp : date}
        })
    }

    return (
        <BlogContext.Provider value={[isLoading, parseContent(datasource)]}>
            {props.children}
        </BlogContext.Provider>
    )
}
